import { type SortOption } from '@discover-data/stores/restaurant/model/sort/options';
import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import usePage from '@discover-data/stores/hooks/page/usePage';
import useSortQueryState from './useQueryState';
import isValidSort from './isValid';
import { sortValues } from './sortOptions';

export default function useSort(): [SortOption, (newSort: SortOption) => Promise<void>] {
  const storeMode = useStoreState((state) => state.mode);
  const storeValue = useStoreState((state) => state.sort.value);
  const setStoreValue = useStoreActions((actions) => actions.sort.set);
  const [, setRouterValue] = useSortQueryState();
  const { resetPage } = usePage();

  async function set(newSort: string) {
    if (isValidSort(newSort, sortValues)) {
      resetPage();

      setStoreValue(newSort);

      await setRouterValue(newSort);
    }
  }

  return [storeValue, set];
}
